// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2987":"434bb8edff788302","8998":"de220d9291a817bd"}[chunkId] + ".js";
};